export default "__VITE_ASSET__CBam3GQi__"